import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Button } from '@safetyhub/ui';
import { adminApi } from '../lib/api';
import GroupList from '../components/user-groups/GroupList';
import GroupCreateModal from '../components/user-groups/GroupCreateModal';
import GroupDetailModal from '../components/user-groups/GroupDetailModal';

export default function UserGroups() {
  const [search, setSearch] = useState('');
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [selectedGroupId, setSelectedGroupId] = useState<string | null>(null);

  const { data, isLoading } = useQuery({
    queryKey: ['admin', 'feature-flag-groups', search],
    queryFn: () => adminApi.getFeatureFlagGroups(search || undefined),
  });

  const groups = data?.data ?? [];

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">사용자 그룹</h1>
          <p className="text-sm text-gray-500 mt-1">
            피처 플래그 오버라이드를 그룹 단위로 관리합니다
          </p>
        </div>
        <Button variant="primary" onClick={() => setShowCreateModal(true)}>
          + 그룹 생성
        </Button>
      </div>

      {/* 검색 */}
      <div className="mb-4">
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="그룹 이름으로 검색..."
          className="w-full max-w-sm px-3 py-2 border border-gray-300 rounded-control text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
        />
      </div>

      {isLoading ? (
        <div className="text-center py-12 text-gray-500">로딩 중...</div>
      ) : (
        <GroupList groups={groups} onSelect={setSelectedGroupId} />
      )}

      {showCreateModal && (
        <GroupCreateModal onClose={() => setShowCreateModal(false)} />
      )}

      {selectedGroupId && (
        <GroupDetailModal
          groupId={selectedGroupId}
          onClose={() => setSelectedGroupId(null)}
        />
      )}
    </div>
  );
}
